import Layout from '@/components/layout/Layout';
import WaitContent from '@/components/tax-refund/result/Wait/WaitContent';

const ResultWaitPage = () => {
  return (
    <Layout>
      <WaitContent />
    </Layout>
  );
};

export default ResultWaitPage;
